import React, {useEffect} from 'react';
import {Link, useParams} from 'react-router-dom';
import {AppContainer} from '../domain/AppContainer';
import {useEntityStore} from '../hooks/useEntityStore';
import {LeagueEvent, LeagueEventsState} from '../domain/leagueevent/models';
import {groupBy, orderBy} from 'lodash';
import {eventToLi} from '../component-library/LeagueEventsList';
import './AllLeagueEvents.css';

interface Props {
    container: AppContainer
}

export function AllLeagueEvents({container}: Props) {
    const {leagueId} = useParams<{leagueId: string}>()
    const events = useEntityStore<LeagueEventsState>(container.leagueEvent.query.events$)

    useEffect(() => {
        if (events.length === 0) {
            container.leagueEvent.service.getAllForLeague()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const doneEvents = events.filter(e => e.status === 'done')
    const byYear = groupBy(doneEvents, (e: LeagueEvent) => new Date(e.dateString).getFullYear())
    const years = orderBy(Object.keys(byYear), y => parseInt(y), 'desc')

    return (
        <div className="all-league-events">
            <Link to={`/league/${leagueId}/manage/events`}>← Back to Events</Link>
            <h2>All Past Events</h2>
            {years.length === 0 && <p>No completed events yet.</p>}
            {years.map(year => (
                <section key={year}>
                    <h3>{year}</h3>
                    <ul>
                        {orderBy(byYear[year], e => e.dateString, 'desc').map(e => {
                            const li = eventToLi(e)
                            return (
                                <li key={String(e.id)}>
                                    <Link to={`/league/${leagueId}/manage/events/${e.id}`}>
                                        {li.displayText}
                                    </Link>
                                </li>
                            )
                        })}
                    </ul>
                </section>
            ))}
        </div>
    )
}
